import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Entity } from "@/model";
import entityRepository from "@/repository/entityRepository";
import { entityQueryKeys } from "./keys";


interface DeleteEntityParams {
    ids?: string[];
    keyword?: string;
    searchType?: string;
    optionList?: string;
}

export const useDeleteEntity = (agentId: number) => {
    const queryClient = useQueryClient();

    return useMutation<Entity, AxiosError, DeleteEntityParams>({
        mutationKey: ["entities", "delete", agentId],
        mutationFn: async (params) => {
            try {
                const { data } = await entityRepository.deleteMany(agentId, params.ids, params.keyword, params.searchType, params.optionList);
                return data.result;
            } catch (e) {
                throw e;
            }
        },
        retry: false,
        onSuccess: async (_, variables) => {
            await queryClient.invalidateQueries({
                queryKey: entityQueryKeys.recent(agentId),
                exact: false
            });
            await queryClient.invalidateQueries({
                queryKey: entityQueryKeys.pageAll(agentId)
            });
            if (variables.ids) {
                await Promise.all(
                    variables.ids.map((id) =>
                        queryClient.invalidateQueries({
                            queryKey: entityQueryKeys.read(agentId, id),
                        })
                    )
                );
            }
        }
    });
};
